
$(document).ready(function () {
    
});
function playCenterVideo() {
    $(".moha--reels--carousel .item video").each(function () {
        this.pause();
    });

    var center = $(".moha--reels--carousel .owl-item.center video")[0];
    if (center) {
        center.play();
    }
}
// Initial play

setTimeout(() => {
    playCenterVideo();
}, "1000");
/* Mobile Menu */
/* const clickDiv = document.getElementById("hamburger");
const targetDiv = document.getElementById("mobileMenu");
const menuClose = document.getElementById("menuClose");
clickDiv.addEventListener("click", function () {
    targetDiv.classList.add("show");
});
menuClose.addEventListener("click", function () {
    targetDiv.classList.remove("show");
}); */


/* Moha Draggable */
const draggableSections = document.querySelectorAll(".moha--dragabble--wrapper");

draggableSections.forEach((section) => {
    let isDown = false;
    let startX;
    let scrollLeft;
    let isDragging = false; // track actual drag vs click

    section.addEventListener("mousedown", (e) => {
        isDown = true;
        isDragging = false;
        startX = e.pageX - section.offsetLeft;
        scrollLeft = section.scrollLeft;
        section.style.cursor = "grabbing";
        section.style.userSelect = "none";        // prevent text selection
        section.style.pointerEvents = "auto";
    });

    section.addEventListener("mouseleave", () => {
        isDown = false;
        isDragging = false;
        section.style.cursor = "grab";
        section.style.userSelect = "";
    });

    section.addEventListener("mouseup", () => {
        isDown = false;
        section.style.cursor = "grab";
        section.style.userSelect = "";
        section.classList.remove("active");

        // Re-enable pointer events on children after drag
        section.querySelectorAll("img, a").forEach(el => {
            el.style.pointerEvents = "";
        });
    });

    section.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();

        const x = e.pageX - section.offsetLeft;
        const walk = (x - startX) * 1.5; // increase for faster scroll

        // Only start dragging after moving 5px (avoids accidental drag)
        if (Math.abs(walk) > 5) {
            isDragging = true;
            section.classList.add("active");

            // Disable pointer events on images/links during drag
            section.querySelectorAll("img, a").forEach(el => {
                el.style.pointerEvents = "none";
            });
        }

        section.scrollLeft = scrollLeft - walk;
    });

    // Prevent click firing after drag
    section.addEventListener("click", (e) => {
        if (isDragging) {
            e.preventDefault();
            e.stopPropagation();
            isDragging = false;
        }
    });

    function checkOverflow() {
        if (section.scrollWidth > section.clientWidth) {
            section.classList.add("is-overflowing");
        } else {
            section.classList.remove("is-overflowing");
        }
    }

    checkOverflow();
    window.addEventListener("resize", checkOverflow);
});
/* End Moha Draggable */
const accordions = document.querySelectorAll('.outer--header input');

accordions.forEach((input) => {
  input.addEventListener('change', function () {
    // if checked → close others
    if (this.checked) {
      accordions.forEach((el) => {
        if (el !== this) el.checked = false;
      });
    }
  });

  input.addEventListener('click', function () {
    // allow toggle close
    if (this.wasChecked) {
      this.checked = false;
      this.wasChecked = false;
    } else {
      this.wasChecked = true;
    }
  });
});


(function () {
  const KEY = "wishlist_v2";

  function getWishlist() {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  }

  function saveWishlist(data) {
    localStorage.setItem(KEY, JSON.stringify(data));
  }

  function toggleWishlist(btn) {
    const id = btn.dataset.productId;
    const handle = btn.dataset.productHandle;
    const variantId = btn.dataset.variantId;

    let wishlist = getWishlist();
    const index = wishlist.findIndex(item => item.id == id);

    if (index > -1) {
      wishlist.splice(index, 1);
      btn.classList.remove("added");
    } else {
      wishlist.push({ id, handle, variantId });
      btn.classList.add("added");
    }

    saveWishlist(wishlist);

    // Sync all buttons of same product
    document.querySelectorAll('.wish--list--featured[data-product-id="'+id+'"]')
      .forEach(el => {
        if (index > -1) {
          el.classList.remove("added");
        } else {
          el.classList.add("added");
        }
      });
  }

  function restoreWishlist() {
    const wishlist = getWishlist();

    document.querySelectorAll(".wish--list--featured").forEach(btn => {
      const id = btn.dataset.productId;

      if (wishlist.some(item => item.id == id)) {
        btn.classList.add("added");
      }
    });
  }

  function init() {
    document.addEventListener("click", function (e) {
      const btn = e.target.closest(".wish--list--featured");
      if (!btn) return;

      e.preventDefault();
      toggleWishlist(btn);
    });

    restoreWishlist();
  }

  document.addEventListener("DOMContentLoaded", init);
})();

/* Cart countdown */
(function () {
  const FREE_SHIPPING_LIMIT = 3500;

  function formatINR(value) {
    return '₹' + (value / 100).toFixed(2);
  }

  function updateShippingBar() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        const cartValue = cart.total_price; // paise
        let remaining = FREE_SHIPPING_LIMIT * 100 - cartValue;

        const bar = document.getElementById('shipping-bar');
        const amountEl = document.getElementById('shipping-remaining');

        if (!bar || !amountEl) return;

        // ✅ clamp value (never go below 0)
        remaining = Math.max(0, remaining);

        if (remaining > 0) {
          amountEl.textContent = formatINR(remaining);
          bar.style.display = 'block';
        } else {
          bar.style.display = 'none'; // free shipping reached
        }
      });
  }

  updateShippingBar();

  document.addEventListener('cart:updated', updateShippingBar);

})();

window.addEventListener("load", function () {
    const bottomValue = window.location.pathname.startsWith("/products/")
        ? "100px"
        : "10px";

    const interval = setInterval(() => {
        const widget = document.getElementById("kiwi-big-iframe-wrapper");

        if (widget) {
            widget.style.setProperty("right", "10px", "important");
            widget.style.setProperty("left", "auto", "important");
            widget.style.setProperty("bottom", bottomValue, "important");

            clearInterval(interval);
        }
    }, 500);
});